import { useQuery } from '@tanstack/react-query'
import { financialService } from '@/services/financial/financial.service'

export const BILLING_STATUS_QUERY_KEY = ['billing-status'] as const

export function useBillingStatus() {
  const query = useQuery({
    queryKey: BILLING_STATUS_QUERY_KEY,
    queryFn: financialService.getBillingConfig,
    staleTime: 1000 * 60 * 5,
    retry: false,
  })

  return {
    isConfigured: !!query.data,
    isLoading: query.isLoading,
    config: query.data,
  }
}
